import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTODocumentApi } from '@/api/pto'
import { updateItemSelect } from '@/store/compositionV2/utils/data/actions'
import { prepareProjectDocumentFormData } from '@/utils/page/pto/project'
import { getUserFullName } from '@/utils/user'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { vuexSaveItemAndFiles } from '@/store/compositionV2/saveItemAndFiles'
import { EAppTableMod } from '@/components/page/table/types'
import router from '@/router'

function getRouteEstimateUpdate (item) {
  return {
    name: 'PtoProjectEstimateUpdate',
    params: {
      id: item.id,
      projectId: router.currentRoute.params.projectId
    }
  }
}

const state = () => ({
  ...vuexPto.createState(),
  ...vuexFileBase.createState(),
  api: PTODocumentApi,
  prepareFormData: prepareProjectDocumentFormData,
  namePageDetailed: 'PtoProjectDocumentUpdate',
  expand: 'status,created_by,file_type,files,estimates',
  tableHeaders: [
    {
      title: 'Наименование',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Дата загрузки',
      isSortable: true,
      sortName: 'updated_at'
    },
    {
      title: '№ сметы',
      isSortable: true,
      sortName: 'estimate_number'
    },
    {
      title: 'Статус',
      isSortable: true,
      sortName: 'status.name'
    },
    {
      title: 'Кто загрузил',
      isSortable: true,
      sortName: 'created_by.surname'
    },
    {
      title: 'Тип файла',
      isSortable: true,
      sortName: 'file_type.name'
    },
    {
      title: 'Примечание',
      isSortable: true,
      sortName: 'note'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  ...vuexFileBase.createGetters(),

  getList: (state, _, rootState) => {
    const fileTypeList = rootState.handbook.pto.documentFileTypeList
    const statusList = rootState.handbook.pto.documentStatusList
    return state.list.map(item => {
      const estimates = {
        mod: EAppTableMod.links,
        data: item.estimates?.map(item => ({
          id: item.id,
          text: item.estimate
        })) || [],
        getRouteHandler: getRouteEstimateUpdate
      }
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.name || '-',
          item.updated_at || '-',
          estimates,
          { data: item.status || '-', name: 'status', list: statusList, mod: 'select' },
          getUserFullName(item.created_by) || '-',
          { data: item.file_type || '-', name: 'file_type', list: fileTypeList, mod: 'select' },
          { data: item.note || '-', mod: 'comments' }
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations(),
  ...vuexFileBase.createMutations()
}

const actions = {
  ...vuexPto.createActions(),
  ...vuexSaveItemAndFiles.createActions(),
  updateItemSelect
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
